export default {"src":"/_next/static/media/calculator.ee05310c.svg","height":661,"width":661,"blurWidth":0,"blurHeight":0};